import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * Old Health links (Pending updates, Reporting, Activity's Alerts) open the
 * matching tab and keep their query, so a link to one update (?proposal=)
 * still opens that update.
 */
export function HealthTabRedirect({ tab }: { tab: string }): React.ReactElement {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set("tab", tab);
  return <Navigate to={`/health?${params.toString()}`} replace />;
}
